import { PayloadAction } from '@reduxjs/toolkit';

import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const setStickyTabsReducer = (state: SidebarState, action: PayloadAction<SidebarState['stickyTabs']>) => {
  state.stickyTabs = action.payload;
};

export default setStickyTabsReducer;
